"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = exports.title = exports.contentContainer = exports.infoIcon = exports.container = void 0;

var react_1 = require("@emotion/react");

var container = function container(showInfoIcon) {
  return react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid var(--gray-200);\n  background-color: ", ";\n"])), showInfoIcon ? 'white' : 'var(--gray-50)');
};

exports.container = container;
exports.infoIcon = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-right: 8px;\n"])));
exports.contentContainer = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
exports.title = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: -0.4px;\n  color: var(--gray-800);\n  margin-bottom: 4px;\n"])));
exports.content = react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  letter-spacing: -0.4px;\n  color: var(--gray-700);\n  white-space: pre-wrap;\n"])));